import { render } from "./hr-footer.vue?vue&type=template&id=037d6b5c&scoped=true"
import script from "./hr-footer.vue?vue&type=script&lang=js"
export * from "./hr-footer.vue?vue&type=script&lang=js"

import "./hr-footer.vue?vue&type=style&index=0&id=037d6b5c&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037d6b5c"]])

export default __exports__